import { Popupator } from './classes/Popupator';

window.popupator = new Popupator();